/* tslint:disable */
import store from '@/store';
import { HttpClient } from '../http-client';
import { UserIdentityModel } from '@/models/file-entities.model';
import i18n from '@/plugins/i18n';

export default (client: HttpClient) => {
  client.instance.interceptors.request.use(request => {
    const rawLocale = String(i18n.locale || '').toLowerCase();
    const language = rawLocale.startsWith('en') ? 'en' : 'es';
    const lang = { 'Accept-Language': language };
    request.headers = { ...request.headers, ...lang };
    
    const tokenStored = (store.state as any).userIdentity
      .userIdentity as UserIdentityModel;
    
    if (tokenStored && tokenStored.token) {
      const tokenExpires = new Date(tokenStored.tokenExpirationDate);
      if (tokenExpires > new Date()) {
        request.headers['Authorization'] = `Bearer ${tokenStored.token}`;
      }
    }

    return request;
  });
};
